import { ICmsDocument } from '@features/cms/typescript';
const getFilteredArticlesByTags = (articles: ICmsDocument[], tags: number[]) => {
  const filteredArticles: ICmsDocument[] = [];
  tags.forEach(tagToFilter => {
    articles.forEach(article => {
      if (article.baseData?.tags && Object.keys(article.baseData?.tags).filter(tagFilter => tagFilter === tagToFilter.toString()).length) {
        filteredArticles?.push(article);
      }
    });
  });
  const uniqueArticles = filteredArticles.filter((filteredArticle, index) => filteredArticles.findIndex(obj => obj.id === filteredArticle.id) === index);
  return uniqueArticles;
};
export default getFilteredArticlesByTags;